import type { SVGProps } from 'react'

// Circle stroke with two vertical rounded bars inside — the classic
// Lucide `pause-circle` glyph. Used for the "Put on hold" row in
// MoreActionsDrawer (prompt 8.24). Matches the stroke conventions of
// MinusCircle (`Skip step`) so the two rows read as a consistent set.
// Rounded line caps produce the "rounded rectangle" bar look without
// switching to fill-based paths.

export default function PauseCircle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="10" x2="10" y1="15" y2="9" />
      <line x1="14" x2="14" y1="15" y2="9" />
    </svg>
  )
}
